import { Injectable } from '@angular/core';
import {ObjectService} from "./abstractions/objects/object.service.abstract";
import {Observable, timeout} from "rxjs";
import {IWorkflowOptions, IWorkflowResponse} from "../../models/workflow-options.model";
import {HttpHeaders, HttpParams} from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class WorkflowsService extends ObjectService<IWorkflowOptions> {

    protected api = '/workflows/'; // Base URL for the client API

    runWorkflowAsync(id: string): Observable<IWorkflowResponse[]> {
        // Set timeout to 1 hour (3600000 ms)
        return this.http.get<IWorkflowResponse[]>(this.getEndpoint() + id + '/run', {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            params: new HttpParams(), // Add params if needed
        }).pipe(
            timeout(3600000) // 1 hour timeout
        );
    }

    proposeWorkflowsAsync(): Observable<IWorkflowOptions[]> {
        return this.http.get<IWorkflowOptions[]>(this.getEndpoint() + 'propose');
    }

    downloadExcelFileForWorkflowAsync(results: IWorkflowResponse[]): Observable<Blob> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        return this.http.post(this.getEndpoint() + 'download', results, { headers, responseType: 'blob' });
    }

    reportAsync(id: string, startDate?: string, endDate?: string): Observable<any> {
        return this.http.get<any>(this.getEndpoint() + id + '/report?startDate=' + startDate + '&endDate=' + endDate);
    }

    reportAllAsync(startDate?: string, endDate?: string): Observable<any> {
        return this.http.get<any>(this.getEndpoint() + 'report?startDate=' + startDate + '&endDate=' + endDate);
    }

    getTaskAsync(id: string, taskId: any) {
        return this.http.get<any>(this.getEndpoint() + id + "/task/" + taskId);
    }

    getAllTasksAsync(id: string) {
        return this.http.get<any>(this.getEndpoint() + id + "/tasks");
    }
}
